import { H1, P } from '@/components/common/Typo'
import { createUrl } from '@/utils/routes'
import { getColorString } from '@/utils/style'
import { Card, cn } from 'oddle-shop-monorepo.design-system'
import LinkButton from './LinkButton'

interface SlideOverlayProps {
  active: boolean
  previewMode: boolean
  enableOverlay?: boolean
  textPosition?: 'left' | 'right' | 'center'
  headingsText?: string
  subheadingsText?: string
  buttonLink?: string
  buttonLabel?: string
  overlayColorDesktop?: {
    r: number
    g: number
    b: number
    a: number
  }
  overlayColorMobile?: string
  textColorDesktop?: string
  textColorMobile?: string
  buttonLabel2?: string
  buttonLink2?: string
  className?: string
}

const SlideOverlay = ({
  active,
  enableOverlay,
  textPosition = 'center',
  headingsText,
  subheadingsText,
  buttonLink,
  previewMode,
  buttonLabel,
  overlayColorDesktop,
  overlayColorMobile,
  textColorDesktop,
  textColorMobile,
  buttonLabel2,
  buttonLink2,
  className,
}: SlideOverlayProps): JSX.Element | null => {
  if (!enableOverlay || (!headingsText && !subheadingsText && !buttonLabel)) {
    return null
  }

  const mobileBgColor = overlayColorMobile || 'var(--color-container)'
  const desktopBgColor = overlayColorDesktop
    ? getColorString(overlayColorDesktop)
    : 'transparent'

  return (
    <Card
      className={cn(
        'bg-container flex h-fit flex-col items-center gap-5 rounded-none p-6 md:mb-[20px] md:rounded-lg',
        'bg-opacity-80 shadow-none md:absolute md:top-1/2 md:mb-0 md:w-[400px] md:shadow-md',
        textPosition === 'right' && 'md:right-[120px]',
        textPosition === 'left' && 'md:left-[120px]',
        textPosition === 'center' && 'md:left-1/2 md:-translate-x-1/2',
        active ? 'md:-translate-y-1/2' : 'md:-translate-y-[calc(50%-20px)]',
        'md:opacity-100 md:transition-all md:delay-300 md:duration-300 md:ease-in-out',
        !active && 'md:opacity-0',
        className
      )}
      style={
        {
          '--overlay-bg-mobile': mobileBgColor,
          '--overlay-text-mobile': textColorMobile || 'inherit',
          '--overlay-text-desktop': textColorDesktop || 'inherit',
          backgroundColor: desktopBgColor,
          color: 'var(--overlay-text-mobile)',
        } as React.CSSProperties
      }
    >
      {headingsText && (
        <H1
          textAlign="center"
          className="text-[var(--overlay-text-mobile)] md:text-[var(--overlay-text-desktop)]"
        >
          {headingsText}
        </H1>
      )}
      {subheadingsText && (
        <P
          textAlign="center"
          marginTop="small"
          marginBottom="none"
          className="m-0 text-[var(--overlay-text-mobile)] md:text-[var(--overlay-text-desktop)]"
        >
          {subheadingsText}
        </P>
      )}
      <div className="flex">
        {buttonLabel && (
          <LinkButton
            previewMode={previewMode}
            href={buttonLink ? createUrl(buttonLink) : '#'}
            className="mt-0"
          >
            {buttonLabel}
          </LinkButton>
        )}
        {buttonLabel2 && buttonLink2 && (
          <LinkButton
            previewMode={previewMode}
            href={createUrl(buttonLink2)}
            className="mt-0"
          >
            {buttonLabel2}
          </LinkButton>
        )}
      </div>
    </Card>
  )
}

SlideOverlay.displayName = 'SlideOverlay'

export default SlideOverlay
